<ax-icon
  *ngIf="isApple"
  class="button"
  [name]="(icon$ | async) || undefined"
  (click)="addToAppleWallet()"
></ax-icon>
